import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { Image } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { CommitmentsSectionProps } from './CommitmentIcons.types';

const CommitmentsSection: React.FC<CommitmentsSectionProps> = (props: CommitmentsSectionProps) => {
  const { eyebrow, title, commitmentsListItems, componentId } = props;
  return (
    <section className={clsx(`lt-text ${componentId}`)}>
      <div className="container p-lg-0">
        <span className="lt-kicker-2">{eyebrow}</span>
        <h3 className="lt-title-3">{title}</h3>
        <div className="row ml-0 mr-0 lt-text-wrap d-flex align-items-stretch">
          {commitmentsListItems?.map((item, index) => (
            <div className="col-6 col-lg-3" key={`commitment-${index}`}>
              <div className="lt-text-item">
                <Image
                  defaultImageURL={item.image?.assetPath}
                  renditions={item.image?.renditions}
                  dynamic={item.image?.dynamic}
                  altText={item.imgAltText}
                  loading="eager"
                />
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const CommitmentIconsConfig = {
  emptyLabel: 'CommitmentIcons',
  isEmpty: () => true,
};

export const CommitmentIcons = (props: CommitmentsSectionProps) => {
  return (
    <div data-testid="commitment-icons" data-component-name="o-prearrival-lovetravels-commitmenticons">
      <EditableComponent config={CommitmentIconsConfig} {...props}>
        <CommitmentsSection {...props} />
      </EditableComponent>
    </div>
  );
};
